import { useGetProgram } from '@interxfi/api-client/program/get-program';
import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';

interface ProgramBreadcrumbProps {
  programId: string;
}

export function ProgramBreadcrumb({ programId }: ProgramBreadcrumbProps) {
  const { data, isPending } = useGetProgram({ programId });

  if (isPending) {
    return <Skeleton charCount={12} />;
  }

  return (
    [data?.program?.data?.details?.name, data?.program?.data?.details?.name ? `(${data.program.programCode})` : data?.program?.programCode]
      .filter(Boolean)
      .join(' ') || `Program ${getShortenedId(programId)}`
  );
}
